import TicketTailorMappingEditor from "./TicketTailorMappingEditor";
export default TicketTailorMappingEditor;
